import React from "react";
import { observer } from "mobx-react";

import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";
import { SportSubheader } from "@features/offer/mobile/shared/sport-subheader";
import PageHeaderTitle from "../../common/PageHeaderTitle";

export const EventPageTitle = observer(function EventPageTitle() {
	const store = useOfferContext<OfferStore.EventViewStore>();

	if (store.getHeaderInfo) {
		return <PageHeaderTitle store={store} />;
	}

	return <SportSubheader />;
});
